let _ = require('lodash');

// Make whole card clickable
function clickableCard(element, link) {

    element.addEventListener('click', (e) => {

        if (link.getAttribute('type') == 'application/pdf' || link.getAttribute('type') == 'video/mp4') {
            window.open(link, '_blank');
        } else {
            window.open(link, '_self');
        }

        if (e.target.type == 'application/pdf' || e.target.type == 'application/zip' || e.target.type == 'video/mp4') {
            e.preventDefault();
        }
    })

    element.style.cursor = 'pointer';
    element.classList.add('clickable');
}

const teasers = document.querySelectorAll('.teaser');

if (!_.isEmpty(teasers)) {
    Array.from(teasers).forEach(teaser => {
        const link = teaser.getElementsByTagName('A')[0];

        if (!_.isNil(link)) {
            clickableCard(teaser, link);
        }
    });
}

(function ($) {
    Drupal.behaviors.myModule = {
        attach: function(context, settings) {
            $(document).ajaxComplete(function (e, xhr, settings) {
                const teasers = document.querySelectorAll('.teaser');

                if (!_.isEmpty(teasers)) {
                    Array.from(teasers).forEach(teaser => {
                        const link = teaser.getElementsByTagName('A')[0];

                        if (! _.isNil(link)) {
                            clickableCard(teaser, link);
                        }
                    });
                }
            });
        }
    }
})(jQuery);

const brochures = document.querySelectorAll('.layout-brochure');

if (!_.isEmpty(brochures)) {
    Array.from(brochures).forEach(brochure => {
        const link = brochure.getElementsByTagName('A')[0];

        if (!_.isNil(link)) {
            clickableCard(brochure, link);
        }
    });
}

const socialMediaImages = document.querySelectorAll('.field--name-field-social-media-images > .field__item');

if (!_.isEmpty(socialMediaImages)) {
    Array.from(socialMediaImages).forEach(image => {
        const link = image.getElementsByTagName('A')[0];

        if (!_.isNil(link)) {
            clickableCard(image, link);
        }
    });
}

const productTeasers = document.querySelectorAll('.layout-product-teaser');

if (!_.isEmpty(productTeasers)) {
    Array.from(productTeasers).forEach(productTeaser => {
        const image = productTeaser.getElementsByTagName('IMG')[0];
        const link = productTeaser.querySelector('.field--name-node-title a');

        if (!_.isNil(image) && !_.isNil(link)) {
            clickableCard(image, link);
        }
    });
}

function externalLinks() {
    for (var c = document.getElementsByTagName("a"), a = 0; a < c.length; a++) {
        var b = c[a];
        b.getAttribute("href") && b.hostname !== location.hostname && (b.target = "_blank")
    }
}

externalLinks();


// Lottie animation
if (!_.isNil(document.getElementById('lottie-thank-you'))) {
    const thankYouAnimation = bodymovin.loadAnimation({
        container: document.getElementById('lottie-thank-you'),
        path: '/themes/custom/ef2_custom/js/lottie-animations/jumping-partners.json',
        renderer: 'svg',
        loop: true,
        autoplay: true,
    });

    // Push purchase data to dataLayer on thank you page
    const purchaseDataString = sessionStorage.getItem('dentaid_purchase_data');
    if (purchaseDataString) {
        try {
            const purchaseData = JSON.parse(purchaseDataString);
            window.dataLayer = window.dataLayer || [];
            window.dataLayer.push({ecommerce: null});
            window.dataLayer.push({
                event: 'purchase',
                ecommerce: {
                    currency: 'EUR',
                    transaction_id: purchaseData.transaction_id,
                    value: purchaseData.value,
                    tax: purchaseData.tax,
                    shipping: purchaseData.shipping,
                    discount: purchaseData.discount,
                    ...(purchaseData.coupon && { coupon: purchaseData.coupon }),
                    items: purchaseData.items,
                }
            });
            sessionStorage.removeItem('dentaid_purchase_data');
        } catch (e) {
            console.error('Error parsing purchase data for dataLayer:', e);
        }
    }
}

// Account menu active class
let myAccountSidebarLinks = document.querySelectorAll('.account-sidebar-menu ul li a');

let currentPath = window.location.pathname;

if (!_.isEmpty(myAccountSidebarLinks)) {
    Array.from(myAccountSidebarLinks).forEach(link => {
        let href = link.getAttribute('href');

        if (_.isEqual(currentPath, href) || currentPath.includes('change-password') && href.includes('change-password')) {
            link.classList.add('active');
        }
    })
}

let mediaDownloadLinks = document.querySelectorAll('.page-node-type-mediafolder span.file > a');

if (!_.isEmpty(mediaDownloadLinks)) {
    Array.from(mediaDownloadLinks).forEach(link => {
        link.setAttribute('download', '');
    });
}


// Remove elements on different breakpoints
let viewportWidth = window.innerWidth || document.documentElement.clientWidth;

if (viewportWidth >= 1380) {
    if (!_.isNil(document.getElementById('block-become-customer-button-mobile'))) {
        document.getElementById('block-become-customer-button-mobile').remove();
    }

} else {
    if (!_.isNil(document.getElementById('block-become-customer-button'))) {
        document.getElementById('block-become-customer-button').remove();
    }
}

if (viewportWidth >= 576) {
    if (!_.isNil(document.getElementById('block-dropdown-language-mobile'))) {
        document.getElementById('block-dropdown-language-mobile').remove();
    }

} else {
    if (!_.isNil(document.getElementById('block-dropdown-language'))) {
        document.getElementById('block-dropdown-language').remove();
    }
}

let userEmail = document.querySelector('.custom-user-form-page .user-register-form input.form-email');

if (!_.isNil(userEmail)) {
    let isFilled = false;

    userEmail.addEventListener('blur', function (e) {
        let userName = document.querySelector('.custom-user-form-page .user-register-form input.username');

        userName.disabled = false;

        if (!isFilled) {
            isFilled = true;
            userName.value = userEmail.value;
        }
    })
}
